import { useState, useEffect } from "react";
import {
    MDBBtn,
    MDBIcon,
    MDBInput,
    MDBModalBody,
    MDBDatatable,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBAlert,
    MDBSpinner,
} from "mdb-react-ui-kit";
import {
    deleteUProvInfo,
    getUProvInfo,
    saveUProvInfo,
    getMisc,
    getFailurReport,
    getSInfo,
    TENANT_URL,
    fetchFailureUsers
} from "../../apiclients/streamsapi_bridge";
import SaveChanges from "../topviews/saveCancel";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ConfirmAlertMS from "./confirm-alert-ms";
import FReport from "./freport-ms";
import { set } from "react-hook-form";
import TabIDConstant from "../../apiclients/TabIDConstant";
import { useRef } from "react";
import { useAdminContext } from "../adminstore/Admin-Context";

const MSUserProvisioning = ({ active, resetKey }) => {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t } = useTranslation();
    const [provEnabled, setProvEnabled] = useState(false);
    const [showProvSettings, setShowProvSettings] = useState(false);
    const [assignDefaultToAll, setAssignDefaultToAll] = useState(true);
    const [servicePlans, setServicePlans] = useState([]);
    const [termTypes, setTermTypes] = useState([]);
    const [initialFormValues, setInitialFormValues] = useState({});
    const [isCopied, setisCopied] = useState(false);
    const [showTokenConfirmModal, setShowTokenConfirmModal] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const [showTokenHelp, setShowTokenHelp] = useState(false);
    const toggleTokenHelp = () => setShowTokenHelp(!showTokenHelp);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [isloading, setIsloading] = useState(false);
    const [showUnsavedModal, setShowUnsavedModal] = useState(false);
    // Inject global edit flags from AdminContext
    const { isEdited, setEdited, isEditedUserProv, setEditedUserProv } = useAdminContext();
    const [updateSuccessMessage, setUpdateSuccessMessage] = useState("");
    const [updateFailureMessage, setUpdateFailureMessage] = useState("");
    const [showDisableConfirmModal, setShowDisableConfirmModal] = useState(false);

    const [formValues, setFormValues] = useState({
        id: "",
        token: "",
        default_sid: "",
        default_term: "",
    });
    const [userValues, setUserValues] = useState({
        email: "",
        fname: "",
        lname: "",
    });
    const [failureUsers, setFailureUsers] = useState([]);
    const [centredModal, setCentredModal] = useState(false);
    const toggleOpenFailureUserReport = () => setCentredModal(!centredModal);
    const tokenRef = useRef(null);
    const defaultSidRef = useRef(null);

    const fixedData = {
        columns: [
            { label: "Sl.No", field: "slno", sort: true },
            { label: "First Name", field: "firstName", sort: true },
            { label: "Last Name", field: "lastName", sort: true },
            { label: "Email", field: "email", sort: false },
            { label: "Failure Reason", field: "failureReason", sort: false },
            { label: "Sync Date", field: "syncDate", sort: true, width: "150" }
        ],
        rows: failureUsers.map((u, index) => ({
            slno: index + 1,
            firstName: u.firstName || u.first_name || "",
            lastName: u.lastName || u.last_name || "",
            email: u.email || "",
            failureReason:
                u.failureReason !== undefined && u.failureReason !== null
                    ? u.failureReason
                    : (u.failure_reason !== undefined && u.failure_reason !== null
                        ? u.failure_reason
                        : ""),
            syncDate:
                u.syncDate || u.sync_date || u.createdAt || u.created_at || ""
        })),
    };



    const tenantURL = TENANT_URL;
    const [userPlans, setUserPlans] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [showFailureReport, setshowFailureReport] = useState(false);
    const [previousToken, setPreviousToken] = useState("");


    useEffect(() => {
        const storedAssignMode = localStorage.getItem("assignMode");
        if (storedAssignMode) {
            setAssignDefaultToAll(storedAssignMode === "auto");
        } else {
            setAssignDefaultToAll(true);
        }
        console.log("Initial assignment mode:", assignDefaultToAll);
        fetchProvisioningInfo();
        fetchServicesInfo();
    }, []);

    const navigate = useNavigate();
    function generate38CharToken() {
        const chars =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        const array = new Uint32Array(38);
        window.crypto.getRandomValues(array);
        let tempToken = Array.from(array, (x) => chars[x % chars.length]).join("");
        setPreviousToken(formValues.token);
        setFormValues((prev) => ({
            ...prev,
            token: tempToken,
        }));
        setFormErrors((prevErrors) => ({
            ...prevErrors,
            token: "",
        }));
        // mark both local and global edit flags
        setEditedUserProv(true);
        setEdited(true);
    }
    useEffect(() => {
        console.log("isEditedUserProv changed:", isEditedUserProv);
    }, [isEditedUserProv]);
    const scrollToError = (errors) => {
        if (errors.token && tokenRef.current) {
            tokenRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
                tokenRef.current.focus();
            }, 300);
        } else if (errors.default_sid && defaultSidRef.current) {
            defaultSidRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
                defaultSidRef.current.focus();
            }, 300);
        }
    };
    function generateToken() {
        return generate38CharToken();
    }
    const handleNavigate = () => {
        if (isEditedUserProv) {
            setShowUnsavedModal(true);
        } else {
            navigate("/userlanding");
        }
    };


    const validateForm = () => {
        const errors = {};

        if (!formValues.token?.trim()) errors.token = "Token is required";
        if (!formValues.default_sid)
            errors.default_sid =
                "Please select a service plan to proceed. This field is required";
        const userErrors = {};
        let userHasErrors = false;
        selectedUsers.forEach((user) => {
            const plan = userPlans[user];
            const userError = {};

            if (!plan?.service_plan) {
                userError.service_plan = "Service Plan is required";
                userHasErrors = true;
            }

            if (!plan?.term_type) {
                userError.term_type = "Term Type is required";
                userHasErrors = true;
            }

            if (Object.keys(userError).length > 0) {
                userErrors[user] = userError;
            }
        });

        if (userHasErrors) errors.users = userErrors;
        setFormErrors(errors);

        // Scroll to first error field if validation fails
        if (Object.keys(errors).length > 0) {
            scrollToError(errors);
        }

        return Object.keys(errors).length === 0;
    };



    const fetchServicesInfo = async () => {
        try {
            const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            const response = await getMisc(siteid, {
                misc: ["services", "term"],
                check_ext: 335,
            });
            if (!response.json) return;
            const tdata = await response.json();
            setServicePlans(tdata.misc.services);
            setTermTypes(tdata.misc.term);
        } catch (error) {
            console.error("Error fetching services info:", error);
        }
    };

    const fetchProvisioningInfo = async () => {
        try {
            const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            const provResponse = await getUProvInfo(siteid, TabIDConstant.USR_PROVISIONING_SUBLINK);
            if (!provResponse.ok) return;
            const provResult = await provResponse.json();

            const provData = provResult[0] || {};

            setProvEnabled(provData.enabled === 1);
            setShowProvSettings(provData.enabled === 1);

            // Ensure proper mapping (0 = Month-to-Month)
            const termValue =
                provData.term_duration == null
                    ? "0"
                    : provData.term_duration.toString();


            setFormValues({
                id: provData.id || "",
                token: provData.token || generateToken(),
                default_sid: provData.service_plan_id?.toString() || "",
                default_term: termValue,
            });

            setInitialFormValues({
                id: provData.id || "",
                token: provData.token || generateToken(),
                default_sid: provData.service_plan_id?.toString() || "",
                default_term: termValue,
            });

            console.log("Fetched provResult:", provData);
        } catch (error) {
            console.error("Error loading provisioning config:", error);
        }
    };



    useEffect(() => {
        fetchProvisioningInfo();
        fetchServicesInfo();
    }, []);
    const handleProvToggle = () => {
        if (provEnabled) {
            // Disabling provisioning - check if it was previously enabled
            if (initialFormValues && initialFormValues.id) {
                setShowDisableConfirmModal(true);
            } else {
                // Not saved yet, just toggle off
                setProvEnabled(false);
                setShowProvSettings(false);
                setEditedUserProv(false);
                setEdited(false);
            }
        } else {
            // Enabling provisioning
            generateToken();
            setProvEnabled(true);
            setShowProvSettings(true);
            setEditedUserProv(true);
            setEdited(true);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
        setFormValues((prev) => ({ ...prev, [name]: value }));
        setEditedUserProv(true);
        setEdited(true);
    };

    const FailureUserReport = async () => {
        const object = {
            failure_users: fixedData?.rows?.map((row) => ({
                firstName: row.firstName || null,
                lastName: row.lastName || null,
                email: row.email || null,
                failureReason: row.failureReason || "No reason provided",
                syncDate: row.syncDate || null,
            })),
        };

        try {
            const response = await getFailurReport(object);
            if (response.ok) {
                const result = await response.json();
                console.log("Failure user report submitted successfully:", result);
            } else {
                console.error("Failed to send failure user report:", response.statusText);
            }
        } catch (error) {
            console.error("Error sending failure user report:", error);
        }
    };



    const loadFailureUserReport = async () => {
        try {
            const response = await fetchFailureUsers();
            if (response.ok) {
                const result = await response.json();
                console.log("Fetched failure users:", result);
                setFailureUsers(result);
            } else {
                console.error("Failed to fetch failure user report");
            }
        } catch (error) {
            console.error("Error fetching failure user report:", error);
        }
    };

    useEffect(() => {
        if (centredModal) {
            loadFailureUserReport();
        }
    }, [centredModal]);

    const clearFormData = () => {
        const clearedForm = {
            id: "",
            token: "",
            default_sid: "",
            default_term: "",
        };

        setFormValues(clearedForm);
        setInitialFormValues({});
        setFormErrors({});
    };

    const submitSave = async (tevent, delFlag) => {
        const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        setEdited(false);
        setEditedUserProv(false);
        setIsloading(true);
        setUpdateSuccessMessage("");
        setUpdateFailureMessage("");

        try {
            if (!provEnabled || delFlag) {
                // === DISABLE PROVISIONING ===
                const response = await deleteUProvInfo(siteid);
                if (response.ok) {
                    setTimeout(() => {
                        setUpdateSuccessMessage("Microsoft Entra ID User Provisioning disabled successfully!");
                        setProvEnabled(false);
                        setShowProvSettings(false);
                        setEditedUserProv(false);
                        setEdited(false);
                        clearFormData();
                        localStorage.removeItem("assignMode");
                        setIsloading(false);

                        setTimeout(() => setUpdateSuccessMessage(""), 5000);
                    }, 3000);
                } else {
                    setTimeout(() => {
                        setIsloading(false);
                        setUpdateFailureMessage("Failed to disable Microsoft Entra ID User Provisioning.");
                        setTimeout(() => setUpdateFailureMessage(""), 5000);
                    }, 3000);
                }
            } else {
                // === ENABLE PROVISIONING ===
                if (assignDefaultToAll) {
                    if (!validateForm()) {
                        setIsloading(false);
                        return;
                    }

                    const defaultTermValue =
                        formValues.default_term === "" || formValues.default_term == null
                            ? "0"
                            : formValues.default_term.toString();

                    const jsonObj = {
                        token: formValues.token,
                        serviceplan: formValues.default_sid,
                        term_duration: defaultTermValue,
                        siteid,
                        enabled: 1,
                        disabled: 0,
                    };

                    const response = await saveUProvInfo(jsonObj);
                    const result = await response.json();

                    if (result?.success || result?.status === 200) {
                        setTimeout(async () => {
                            setUpdateSuccessMessage("Microsoft Entra ID User Provisioning enabled successfully.");

                            const provResponse = await getUProvInfo(siteid, TabIDConstant.USR_PROVISIONING_SUBLINK);
                            if (provResponse.ok) {
                                const provResult = await provResponse.json();
                                const provData = provResult[0] || {};

                                const termValue =
                                    provData.term_duration == null
                                        ? "0"
                                        : provData.term_duration.toString();

                                setFormValues({
                                    id: provData.id || "",
                                    token: provData.token || formValues.token,
                                    default_sid: provData.service_plan_id?.toString() || jsonObj.serviceplan || "",
                                    default_term: termValue || jsonObj.term_duration || "0",
                                });

                                setInitialFormValues({
                                    id: provData.id || "",
                                    token: provData.token || formValues.token,
                                    default_sid: provData.service_plan_id?.toString() || jsonObj.serviceplan || "",
                                    default_term: termValue || jsonObj.term_duration || "0",
                                });
                            }

                            setProvEnabled(true);
                            setShowProvSettings(true);
                            // Clear both edit flags after successful save
                            setEditedUserProv(false);
                            setEdited(false);
                            setIsloading(false);

                            setTimeout(() => setUpdateSuccessMessage(""), 5000);
                        }, 3000);
                    } else {
                        setTimeout(() => {
                            setIsloading(false);
                            setUpdateFailureMessage("Failed to enable Microsoft Entra ID User Provisioning.");
                            setTimeout(() => setUpdateFailureMessage(""), 5000);
                        }, 3000);
                    }
                }
            }
        } catch (error) {
            console.error("Error submitting provisioning config:", error);
            setIsloading(false);
            setUpdateFailureMessage("An unexpected error occurred while saving provisioning configuration.");
            setTimeout(() => setUpdateFailureMessage(""), 5000);
        }
    };



    const copyToClipboard = () => {
        navigator.clipboard.writeText(formValues.token || "").then(() => {
            setisCopied(true);
            setTimeout(() => setisCopied(false), 2000);
        });
    };

    const copyURLToClipboard = () => {
        navigator.clipboard.writeText(tenantURL).then(() => {
            setisCopied(true);
            setTimeout(() => setisCopied(false), 2000);
        });
    };

    const revertToPreviousValues = () => {
        if (initialFormValues && Object.keys(initialFormValues).length > 0) {
            setFormValues(initialFormValues);
            setProvEnabled(initialFormValues.id ? true : false);
            setShowProvSettings(initialFormValues.id ? true : false);
        } else {
            setFormValues({
                id: "",
                token: "",
                default_sid: "",
                default_term: "",
            });
            setProvEnabled(false);
            setShowProvSettings(false);
        }
        // ensure both flags cleared
        setEditedUserProv(false);
        setEdited(false);
        setFormErrors({});
    };
    useEffect(() => {
        if (resetKey === undefined) return; // guard for first render if you want
        // call existing function to revert local fields and clear local edit flags
        try {
            revertToPreviousValues();
        } catch (err) {
            console.error("Failed to revert on resetKey change:", err);
        }
    }, [resetKey]);

    return (
        <>
            {isloading && (
                <div className="loadingclass-popup">
                    <div className="popup-bg-loader">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </div>
            )}

            <div className="mx-auto" style={{ paddingRight: "10%" }}>
                {/* Enable Provisioning Toggle */}
                <div className="add-numbermain">
                    <div className="tel-numbers">
                        <span>Enable User Provisioning with Microsoft Entra ID</span>
                        <br />
                        <span className="phrecording text-secondary fs-small w-90 d-inline-block">
                            {t("MSEnableUserProvisioning")}
                        </span>
                    </div>
                    <div>
                        <label className="switch">
                            <input
                                className="form-control"
                                type="checkbox"
                                checked={provEnabled}
                                onChange={handleProvToggle}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>

                {showProvSettings && provEnabled && (
                    <>
                        <div className="routing-border mt-0 pt-0"></div>

                        <div className="tel-numbers fw-bold add-numbermain noHoverBg">
                            API Information
                        </div>
                        <div className="add-numbermain">
                            <div className="tel-numbers">Tenant URL</div>
                            <div className="w-30">
                                <div className="position-relative d-flex align-items-center">
                                    <MDBInput
                                        name="tenantURL"
                                        value={tenantURL}
                                        disabled={true}
                                        className="w-100"
                                    />
                                    <MDBIcon
                                        far
                                        icon="copy"
                                        className="cursor-pointer ms-2"
                                        color="primary"
                                        onClick={copyURLToClipboard}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="add-numbermain">
                            <div className="tel-numbers">Token</div>
                            <div className="w-30">
                                <div className="position-relative d-flex align-items-center">
                                    <MDBInput
                                        inputRef={tokenRef}
                                        name="token"
                                        value={formValues.token}
                                        onChange={handleInputChange}
                                        maxLength={40}
                                        disabled={true}
                                        className="w-100"
                                    />
                                    <MDBIcon
                                        far
                                        icon="copy"
                                        className="cursor-pointer ms-2"
                                        color="primary"
                                        onClick={copyToClipboard}
                                    />
                                </div>
                                <MDBBtn
                                    className="mb-1 mt-2"
                                    onClick={() => setShowTokenConfirmModal(true)}
                                >
                                    Generate New Token
                                </MDBBtn>
                                {formErrors.token && (
                                    <span style={{ color: "red" }}>{formErrors.token}</span>
                                )}
                            </div>
                        </div>

                        <span className="phrecording text-secondary fs-small w-100 d-inline-block text-end">
                            {t("UserGenerateToken")}
                            <br />
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    toggleTokenHelp();
                                }}
                                rel="noopener noreferrer"
                                style={{
                                    color: "#007bff",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                }}
                            >
                                Click here
                            </a>{" "}
                            for more information.
                        </span>

                        {/* Default Settings - Always Auto Assign Mode */}
                        <div className="add-numbermain">
                            <div className="tel-numbers fw-500">Default Settings</div>
                        </div>

                        <div className="add-numbermain">
                            <div className="tel-numbers">Service Plan</div>
                            <div className="w-30">
                                <select
                                    ref={defaultSidRef}
                                    name="default_sid"
                                    className="form-select"
                                    value={formValues.default_sid}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Select Service Plan</option>
                                    {servicePlans.map((sp) => (
                                        <option key={sp.id} value={sp.id}>
                                            {sp.name}
                                        </option>
                                    ))}
                                </select>
                                {formErrors.default_sid && (
                                    <span style={{ color: "red" }}>{formErrors.default_sid}</span>
                                )}
                            </div>
                        </div>

                        <div className="add-numbermain">
                            <div className="tel-numbers">Term Type</div>
                            <div className="w-30">
                                <select
                                    name="default_term"
                                    className="form-select"
                                    value={formValues.default_term || "0"}
                                    onChange={handleInputChange}
                                >
                                    {termTypes.map((term) => (
                                        <option key={term.duration} value={term.duration}>
                                            {term.duration === 0
                                                ? "Month-to-Month"
                                                : `${term.duration} months`}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="add-numbermain">
                            <div className="tel-numbers">
                                Download Service Plans and Term Codes for Mapping
                            </div>
                            <MDBBtn
                                className="px-4"
                                onClick={async () => {
                                    try {
                                        setIsloading(true);
                                        const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;

                                        // Backend will fetch account-specific service plans and terms
                                        const response = await getSInfo(siteid);

                                        if (!response.ok) throw new Error("Failed to download PDF");

                                        const blob = await response.blob();
                                        const url = window.URL.createObjectURL(new Blob([blob]));
                                        const link = document.createElement("a");
                                        link.href = url;
                                        link.setAttribute("download", "entra_provisioning_guide.pdf");
                                        document.body.appendChild(link);
                                        link.click();
                                        link.remove();
                                        setIsloading(false);
                                    } catch (error) {
                                        console.error("Error downloading provisioning guide:", error);
                                        setIsloading(false);
                                        setUpdateFailureMessage("Failed to download the provisioning guide. Please try again.");
                                        setTimeout(() => setUpdateFailureMessage(""), 5000);
                                    }
                                }}
                            >
                                Download
                            </MDBBtn>
                        </div>

                        <div className="tel-numbers add-numbermain noHoverBg">
                            <div className="tel-numbers">
                                <span>Provisioning Summary Notification :</span>
                                <br />
                                <span className="phrecording text-secondary fs-small w-90 d-inline-block">
                                    {t("MSReviewReviewProvisionResult")}
                                </span>
                            </div>
                        </div>

                        <div className="add-numbermain">
                            <div className="tel-numbers">Failure User(s) Report</div>
                            <MDBBtn className="px-4" onClick={toggleOpenFailureUserReport}>
                                View
                            </MDBBtn>
                        </div>
                        <MDBModal
                            tabIndex="-1"
                            open={centredModal}
                            onClose={() => setCentredModal(false)}
                        >
                            <MDBModalDialog centered size="xl">
                                <MDBModalContent>
                                    <MDBModalHeader>
                                        <MDBModalTitle>Failure User Report</MDBModalTitle>
                                        <MDBBtn
                                            className="btn-close"
                                            color="none"
                                            onClick={toggleOpenFailureUserReport}
                                        ></MDBBtn>
                                    </MDBModalHeader>
                                    <MDBModalBody>
                                        <MDBDatatable
                                            multi
                                            data={fixedData}
                                            pagination={false}
                                            className="mt-0"
                                        />
                                        <MDBBtn
                                            className="mt-3"
                                            onClick={async () => {
                                                await FailureUserReport();
                                                setCentredModal(false);
                                            }}
                                        >
                                            Ok
                                        </MDBBtn>
                                    </MDBModalBody>
                                </MDBModalContent>
                            </MDBModalDialog>
                        </MDBModal>

                        <div className="add-numbermain">
                            <div className="tel-numbers">
                                <span>Managing Provisioned Users</span>
                                <br />
                                <span className="phrecording text-secondary fs-small d-inline-block">
                                    To edit the information of provisioned users, navigate to
                                    Users &gt;
                                    <span
                                        style={{
                                            color: "#007bff",
                                            cursor: "pointer",
                                            marginLeft: "4px",
                                            textDecoration: "underline",
                                        }}
                                        onClick={() => handleNavigate()}
                                        className=""
                                    >
                                        Users
                                    </span>
                                </span>
                            </div>
                        </div>
                    </>
                )}

                {isEditedUserProv && (
                    <SaveChanges
                        onClose={revertToPreviousValues}
                        onSave={submitSave}
                    />
                )}


            </div>

            {/* Failure Report Modal (external) */}
            {showFailureReport && (
                <FReport
                    showSSODisableModal={showFailureReport}
                    setShowSSODisableModal={setshowFailureReport}
                    onCancel={() => {
                        setshowFailureReport(false);
                    }}
                />
            )}

            {/* Confirm Alert Modal for disabling */}
            {showDisableConfirmModal && (
                <ConfirmAlertMS
                    showSSODisableModal={showDisableConfirmModal}
                    setShowSSODisableModal={setShowDisableConfirmModal}
                    messagehead="Disable User Provisioning"
                    message="Are you sure you want to disable User Provisioning? This action will permanently delete the existing configuration."
                    onConfirm={async () => {
                        try {
                            setShowDisableConfirmModal(false);
                            await submitSave(null, true);
                        } catch (err) {
                            console.error("Error disabling provisioning:", err);
                            setIsloading(false);
                        }
                    }}

                    onCancel={() => {
                        setShowDisableConfirmModal(false);
                    }}
                />
            )}
            {updateSuccessMessage && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="success"
                    autohide
                    position="bottom-right"
                    delay={10000}
                >
                    <i className="fas fa-check-circle me-3"></i>
                    <span className="alert-msg">{updateSuccessMessage}</span>
                </MDBAlert>
            )}

            {updateFailureMessage && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                >
                    {updateFailureMessage}
                </MDBAlert>
            )}


            {showTokenConfirmModal && (
                <ConfirmAlertMS
                    showSSODisableModal={showTokenConfirmModal}
                    setShowSSODisableModal={setShowTokenConfirmModal}
                    messagehead="Generate New Token"
                    message="After generating a new token, make sure to update it in your Microsoft Entra ID configuration as well."
                    onConfirm={() => {
                        generate38CharToken();
                        setShowTokenConfirmModal(false);
                    }}
                    onCancel={() => {
                        setShowTokenConfirmModal(false);
                    }}
                />
            )}

            {isCopied && (
                <MDBAlert
                    open
                    color="dark"
                    autohide
                    position="bottom-right"
                    delay={2000}
                    onClose={() => setisCopied(false)}
                    className="copied-alert"
                >
                    Copied to clipboard
                </MDBAlert>
            )}
            {showTooltip && (
                <MDBAlert
                    open
                    color="success"
                    autohide
                    className="alert-center"
                    position="bottom-right"
                    delay={2000}
                    onClose={() => setShowTooltip(false)}
                >
                    <MDBIcon far icon="check-circle" color="success" className="me-2" />
                    Copied to clipboard
                </MDBAlert>
            )}
            {showUnsavedModal && (
                <ConfirmAlertMS
                    showSSODisableModal={showUnsavedModal}
                    setShowSSODisableModal={setShowUnsavedModal}
                    messagehead="Warning"
                    message="There are unsaved changes. Click Continue to proceed without saving or Cancel to remain on the current page."
                    onConfirm={() => {
                        setShowUnsavedModal(false);
                        setEditedUserProv(false);
                        setEdited(false);
                        navigate("/userlanding");
                    }}
                    onCancel={() => {
                        setShowUnsavedModal(false);
                    }}
                />
            )}

            {/* MDB Modal */}
            <MDBModal open={showTokenHelp} setShow={setShowTokenHelp} tabIndex="-1">
                <MDBModalDialog size="lg">
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>
                                Updating the Provisioning Token in Microsoft Entra ID
                            </MDBModalTitle>
                            <MDBBtn
                                className="btn-close"
                                color="none"
                                onClick={toggleTokenHelp}
                            ></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <p>
                                If you have generated a new SCIM token in your application, you
                                need to update it in Microsoft Entra ID so that user
                                provisioning continues to work.
                            </p>

                            <h6>Steps to Update the Token:</h6>
                            <ol>
                                <li>
                                    Sign in to the{" "}
                                    <a
                                        href="https://entra.microsoft.com"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Microsoft Entra admin center
                                    </a>{" "}
                                    with an account that has Application Administrator or Cloud
                                    Application Administrator privileges.
                                </li>
                                <li>
                                    Go to <strong>Enterprise applications</strong> '{" "}
                                    <em>Select your application</em> '{" "}
                                    <strong>Provisioning</strong>.
                                </li>
                                <li>
                                    Click <strong>Edit Provisioning</strong>.
                                </li>
                                <li>
                                    In the <strong>Admin Credentials</strong> section:
                                    <ul>
                                        <li>
                                            Find <strong>Secret Token</strong> (or Bearer Token).
                                        </li>
                                        <li>
                                            Replace the old token with your new SCIM token from your
                                            app.
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    Click <strong>Test Connection</strong> to verify it works.
                                </li>
                                <li>
                                    Click <strong>Save</strong> and restart provisioning if
                                    required.
                                </li>
                            </ol>

                            <h6>When Should You Update the Token?</h6>
                            <ul>
                                <li>If your old token has expired.</li>
                                <li>If it was revoked for security reasons.</li>
                                <li>After generating a new SCIM token in your application.</li>
                            </ul>

                            <p>
                                <em>
                                    Tip: Update the token immediately after regenerating it to
                                    avoid interruptions.
                                </em>
                            </p>
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>
    );
};

export default MSUserProvisioning;
